import styled from 'styled-components'
import { colors } from '../../styles/vars/colors.style'
import { zIndex } from '../../styles/vars/zIndex.style'
import { mq } from '../../styles/vars/media-queries.style'

export const MenuToggleWrapper = styled.div`
  position: relative;
  z-index: ${zIndex.mobileNavButtons};
`

export const MenuToggleMain = styled.button`
  position: relative;
  /* width: 4.4rem; */
  height: 4.4rem;
  color: currentColor;
  background-color: transparent;
  border: none;

  ${mq.tabletL} {
    display: none;
  }
`

export const MenuCircle = styled.div`
  background-color: ${colors.dark};
  border-radius: 50%;
  overflow: hidden;
  height: 1.5rem;
  position: absolute;
  top: calc(50% - 0.05rem);
  left: calc(50% + 1.2rem);
  width: 1.5rem;
`
export const MenuToggleBar = styled.div`
  text-transform: uppercase;
  /* position: absolute;
  top: calc(50% - 0.05rem);
  left: calc(50% - 1.8rem);
  width: 3.6rem;
  height: 0.1rem;
  background-color: ${colors.dark};

  :first-child {
    transform: translateY(-0.4rem);
  }

  :last-child {
    transform: translateY(0.4rem);
  } */
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: all 0.2s ease;
`
